<template>
  <div
    :class="[
      'mx-auto grid w-full gap-8 px-4 py-4 sm:grid-cols-3 sm:px-8 md:gap-x-16 lg:gap-x-24 xl:gap-x-32',
      $slots.filter
        ? 'sm:max-w-(--breakpoint-lg)'
        : 'sm:max-w-(--breakpoint-md)',
    ]"
  >
    <header v-if="$slots.header" class="sm:col-span-3">
      <slot name="header"></slot>
    </header>
    <div v-if="$slots.title" class="block sm:hidden">
      <slot name="title"></slot>
    </div>
    <div v-if="$slots.filter" class="sm:col-span-1">
      <slot name="filter"></slot>
    </div>

    <main
      :class="[
        'flex h-full flex-col gap-8',
        $slots.filter ? 'sm:col-span-2' : 'sm:col-span-3',
      ]"
    >
      <div v-if="$slots.title" class="hidden sm:block">
        <slot name="title"></slot>
      </div>
      <slot v-if="$slots.content" name="content"></slot>
    </main>
    <slot></slot>
  </div>
</template>

<script lang="ts" setup></script>
